import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { PrivateCompanyLeadsFunnelUpdateValidationSchema } from "@/features/privateCompanyLeadsFunnel/schemas/update.schema";
import { getCleanPayload } from "@/common/utils/getCleanPayload";

interface UseUpdatePrivateCompanyLeadManangersProps {
  id?: string
  onSuccess: () => void
  onError: (error: any) => void
}

const useUpdatePrivateCompanyLeadManagers = ({ id, onSuccess, onError }: UseUpdatePrivateCompanyLeadManangersProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['updatePrivateCompanyLeadManagers'],
    mutationFn: (data: Partial<PrivateCompanyLeadsFunnelUpdateValidationSchema>) => {
      const payload = {
        commercial_manager_id: data.commercial_manager?.value,
        commercial_manager_substitute_id: data.commercial_manager_substitute !== undefined
          ? data.commercial_manager_substitute?.value || null
          : undefined,
      }

      return privateAxios.put(`/funnel/private_company_leads/${id}/update_managers`, {
        private_company_lead: getCleanPayload(payload),
      });
    },
    onSuccess,
    onError,
  });
}

export default useUpdatePrivateCompanyLeadManagers
